import { IPAD_PRO_LANDSCAPE_MAX_WIDTH, screenSizes } from "@/assets/theme/sizes";
import { useWindowSize } from "@/hooks/useWindowSize";

export function isDashboardSingleColumn(width = window.innerWidth) {
  // Keep dashboard panels stacked through iPad Pro landscape. Two-column resumes on wider desktops.
  return width <= IPAD_PRO_LANDSCAPE_MAX_WIDTH;
}

export function isDashboardStackedTableRows(width = window.innerWidth) {
  // Stack row cells below lg (phones + iPad portrait). iPad landscape and up keep spread-out columns.
  return width < screenSizes.lg;
}

export default function useIsDashboardSingleColumn() {
  const { width } = useWindowSize();

  return isDashboardSingleColumn(width);
}

export function useIsDashboardStackedTableRows() {
  const { width } = useWindowSize();

  return isDashboardStackedTableRows(width);
}
